module.exports = __webpack_public_path__ + "static/media/NYPresbyterian.caa36e99.png";